export default next =>
  (next && next.href && parseInt((next.href.match(/start=(\d*)/) || [])[1], 10)) || 0;
